<div id="bug-report-container" #bugContainer>
  @if (!loading && !showCanvas) {
    <div
      class="w-full h-20 text-white bg-app-secondary border border-app-white-50 rounded-lg justify-center items-center flex flex-col font-bold gap-2 cursor-pointer mb-8"
      (click)="DrawPic()"
    >
      Take a screenshot
      <span
        class="text-xl"
        nz-icon
        nzType="camera"
        nzTheme="outline"
        style="color: white"
      ></span>
    </div>
  }
  @if (loading) {
    <div
      class="w-full h-20 text-app-dark bg-app-white-75 border border-app-white-50 rounded-lg justify-center items-center flex flex-col font-bold gap-2 cursor-pointer mb-8"
    >
      <nz-spin nzSimple></nz-spin>Taking screenshot...
    </div>
  }
  <div class="relative mb-8" [hidden]="!showCanvas">
    <img
      src="{{ imagePath }}"
      class="w-full rounded-lg border border-app-white-50"
    />

    <div class="flex justify-end mt-2">
      <button
        type="button"
        class="flex flex-col justify-center items-center bg-app-secondary hover:bg-app-secondary-hover border duration-300 w-full rounded-lg p-4 text-white font-medium"
        (click)="downloadImage()"
      >
        Download Image
        <i
          nz-icon
          nzType="download"
          nzTheme="outline"
          class="text-app-white"
        ></i>
      </button>
    </div>
  </div>

  <form nz-form [formGroup]="bugForm" [nzLayout]="'vertical'">
    <div nz-row [nzGutter]="10">
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired nzFor="name"
            >Title
          </nz-form-label>
          <nz-form-control
            [nzSm]="24"
            [nzXs]="24"
            nzErrorTip="Please enter a short title (at least 5 characters)."
            class="rounded-2xl"
          >
            <input
              nz-input
              placeholder="e.g., Save button not working"
              formControlName="title"
            />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired nzFor="name"
            >Please select a reason
          </nz-form-label>
          <nz-form-control
            [nzSm]="24"
            [nzXs]="24"
            nzErrorTip="Please select a reason"
            class="rounded-2xl"
          >
            <nz-select formControlName="reason">
              @for (sev of bugSeverties; track sev) {
                <nz-option [nzValue]="sev" [nzLabel]="sev"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <nz-form-item>
      <nz-form-label [nzSm]="24" [nzXs]="24" nzRequired
        >Describe us the problem or a suggestion:
      </nz-form-label>
      <nz-form-control
        [nzSm]="24"
        [nzXs]="24"
        nzErrorTip="Please select a description"
      >
        <div class="NgxEditor__Wrapper mb-3 h-40">
          <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
          </ngx-editor-menu>
          <ngx-editor
            [editor]="editor"
            formControlName="description"
            [disabled]="false"
            [placeholder]="'Type here...'"
          ></ngx-editor>
        </div>
      </nz-form-control>
    </nz-form-item>
  </form>

  <div class="flex justify-end">
    @if (
      {
        loading: loading$ | async,
      };
      as data
    ) {
      <button
        class="mt-2 bg-app-secondary duration-300 w-full rounded-lg p-4 text-white hover:bg-app-secondary-hover hover:text-app-primary font-medium flex justify-center items-center"
        (click)="submitBug()"
        [disabled]="data.loading"
      >
        <span class="mr-2">{{
          data.loading ? 'Processing...' : 'Submit'
        }}</span>
        <span
          *ngIf="data.loading"
          class="bg-app-secondary text-white z-50 w-4 h-4 rounded-full flex items-center justify-center"
          nz-icon
          nzType="loading"
          nzTheme="outline"
        ></span>
      </button>
    }
  </div>
</div>
